module.exports = __webpack_public_path__ + "img/Andaluza-28-min.f62b51f4.jpg";